import { Injectable } from '@angular/core';
import {
  BasePageMetaResolver,
  BreadcrumbMeta,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  ProductSearchService,
  RoutingService,
  SearchPageMetaResolver,
  TranslationService,
} from '@spartacus/core';
import { combineLatest, Observable, of } from 'rxjs';
import { ProductListService } from './product-list.service';
import { switchMap, mergeMap, map, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KbSearchPageMetaResolver
  extends SearchPageMetaResolver
  implements PageDescriptionResolver, PageBreadcrumbResolver
{
  protected override total$: Observable<number | undefined> = combineLatest([
    this.productListService.countDetails$,
    this.productListService.selectedTabIndex,
  ]).pipe(
    filter(([countDetail]) => countDetail != null),
    map(([countDetail, selectedTab]) => {
      switch (selectedTab) {
        case 0:
          return countDetail?.productModel?.pagination?.totalResults;
        case 1:
          return countDetail?.crossRefModel?.pagination?.totalResults;
        case 2:
          return countDetail?.docModel?.pagination?.totalResults;
        case 3:
          return countDetail?.softwareModel?.pagination?.totalResults;
        default:
          return 0;
      }
    })
  );
  constructor(
    routingService: RoutingService,
    productSearchService: ProductSearchService,
    translation: TranslationService,
    basePageMetaResolver: BasePageMetaResolver,
    public productListService: ProductListService
  ) {
    super(routingService, productSearchService, translation, basePageMetaResolver);
  }
  resolveDescription() {
    return this.basePageMetaResolver.resolveDescription();
  }

  override resolveTitle(): Observable<string> {
    const sources = [
      this.total$,
      this.query$,
      this.translation.translate('pageMetaResolver.search.default_title'),
      this.translation.translate('common.kb_search_result_breadcrumb'),
    ];
    return combineLatest(sources).pipe(
      map(([count, query, defaultQuery, resultText]) => `${count} ${resultText} ${query || defaultQuery}`)
    );
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return combineLatest([this.resolveTitle(), this.translation.translate('common.breadcrumb_home')]).pipe(
      map(([title, homeLabel]) => {
        const breadcrumbs: BreadcrumbMeta[] = [];
        breadcrumbs.push({ label: homeLabel, link: '/' });
        breadcrumbs.push({ label: title?.split('|').length ? title?.split('|')[0] : title, link: '' });
        return breadcrumbs;
      })
    );
  }
}
